import React, { useEffect, useState } from "react";
import "./StatusFilter.css";
import QuickQuestionFilter from "./QuickQuestionFilter";

const StatusFilter = ({
  topFilters = [],
  quickFilterGroups = [],
  selectedFilters = {},
  onSelectTopFilter,
  onApplyQuickFilters,
  onResetQuickFilters,
  adCoins = 0,
  isLoading = false,
}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const openFilters = () => {
    setIsFilterOpen(true);
  };

  const closeFilters = () => {
    setIsFilterOpen(false);
  };

  useEffect(() => {
    if (!isFilterOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeFilters();
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeyDown);

      return () => {
        document.body.style.overflow = "";
        window.removeEventListener("keydown", handleKeyDown);
      };
  }, [isFilterOpen]);

  if (isLoading) {
    return (
      <>
        <div className="status-filter" aria-hidden="true">
          {Array.from({ length: 3 }).map((_, index) => (
            <span
              key={`status-filter-skeleton-${index}`}
              className="dashboard-skeleton dashboard-skeleton--button status-filter__shimmer-pill"
            />
          ))}
          <span className="dashboard-skeleton dashboard-skeleton--button status-filter__shimmer-coins" />
          <span className="dashboard-skeleton dashboard-skeleton--icon status-filter__shimmer-icon d-flex d-lg-flex d-xl-none" />
        </div>

        <div id="qbank-filter-drawer" className={`qbl-filterPanel ${isFilterOpen ? "is-open" : ""}`}>
          <QuickQuestionFilter className={isFilterOpen ? "is-open" : ""} isLoading />
        </div>
      </>
    );
  }

  return (
    <>
      <div className="status-filter">
        {topFilters.map((filter) => (
          <button
            key={filter.id}
            type="button"
            className={`status-btn ${
              selectedFilters?.[filter.filterKey] === filter.value ? "active" : ""
            }`}
            onClick={() => onSelectTopFilter?.(filter)}
          >
            {filter.title}
          </button>
        ))}

        <span className="ad-coins-btn" role="status">
          <span className="play-icon">
            <i className="fa-solid fa-coins"></i>
          </span>
          Ad Coins: {adCoins}
        </span>

        <button
          type="button"
          className="quizz-Filter-icon d-flex d-lg-flex d-xl-none"
          onClick={openFilters}
          aria-label="Open filters"
          aria-expanded={isFilterOpen}
          aria-controls="qbank-filter-drawer"
        >
          <span className="quizz-Filter">
            <i className="bi bi-sliders2"></i>
          </span>
        </button>
      </div>

      <div
        className={`qbl-filterBackdrop ${isFilterOpen ? "is-open" : ""}`}
        onClick={closeFilters}
        aria-hidden="true"
      />

      <div id="qbank-filter-drawer" className={`qbl-filterPanel ${isFilterOpen ? "is-open" : ""}`}>
        <QuickQuestionFilter
          className={isFilterOpen ? "is-open" : ""}
          groups={quickFilterGroups}
          selectedFilters={selectedFilters}
          onApplyFilters={onApplyQuickFilters}
          onReset={onResetQuickFilters}
          onClose={closeFilters}
          isLoading={isLoading}
          isOpen={isFilterOpen}
        />
      </div>
    </>
  );
};

export default StatusFilter;
